export default "__VITE_ASSET__ba0ea3c0__"